import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { CssBaseline, ThemeProvider } from '@mui/material';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';

import App from './App';
import { applyBrandHead } from './branding/brand';
import theme from './config/theme';
import './index.css';
import { msalConfig } from './msalConfig';
import reportWebVitals from './reportWebVitals';
import store from './store';

const msalInstance = new PublicClientApplication(msalConfig);

const rootElement = document.getElementById('root') as HTMLElement;

if (!rootElement) {
  throw new Error('Root element with id="root" not found');
}

const root = ReactDOM.createRoot(rootElement);

applyBrandHead();

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <MsalProvider instance={msalInstance}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <App />
        </ThemeProvider>
      </MsalProvider>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
